import React from "react";
import type { BlocksContent } from "@strapi/blocks-react-renderer";
import { BaseBlocksRenderer } from "@ui/components/common/base-blocks-renderer";
import { announcementBlocksOverrides } from "@ui/components/common/blocks-overrides";

export const AnnouncementRenderer: React.FC<{ content: BlocksContent }> = ({ content }) => (
	<BaseBlocksRenderer content={content} blocks={announcementBlocksOverrides} />
);
